import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=4027d8e0&scoped=true&"
import script from "./exam.vue?vue&type=script&lang=js&"
export * from "./exam.vue?vue&type=script&lang=js&"
import style0 from "./exam.vue?vue&type=style&index=0&id=4027d8e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027d8e0",
  null
  
)

export default component.exports